import { forwardRef } from 'react'
import { Box, Divider } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit'
interface MapControlsProps {
    onZoomIn: () => void
    onZoomOut: () => void
    onZoomReset?: () => void
    isZoomInDisabled?: boolean
    isZoomOutDisabled?: boolean
    isFullscreen: boolean
    onToggleFullscreen: () => void
}

const MapControls = forwardRef<HTMLDivElement, MapControlsProps>(
    (
        {
            onZoomIn,
            onZoomOut,
            onZoomReset,
            isZoomInDisabled = false,
            isZoomOutDisabled = false,
            isFullscreen,
            onToggleFullscreen,
        },
        ref,
    ) => {
        return (
            <>
                {/* Fullscreen Toggle - top right */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                        zIndex: 999,
                        display: 'flex',
                        background: 'rgba(255,255,255,0.9)',
                        borderRadius: 1,
                        boxShadow: 2,
                        cursor: 'pointer',
                        width: 40,
                        height: 40,
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    onClick={onToggleFullscreen}
                    title={isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
                >
                    {isFullscreen ? (
                        <FullscreenExitIcon
                            sx={{ color: '#666666', fontSize: 22 }}
                        />
                    ) : (
                        <FullscreenIcon
                            sx={{ color: '#666666', fontSize: 22 }}
                        />
                    )}
                </Box>

                {/* Zoom Controls - bottom right */}
                <Box
                    ref={ref}
                    sx={{
                        position: 'absolute',
                        bottom: 16,
                        right: 10,
                        zIndex: 999,
                        display: 'flex',
                        flexDirection: 'column',
                        background: 'rgba(255,255,255,0.9)',
                        borderRadius: 1,
                        boxShadow: 2,
                    }}
                >
                    {onZoomReset !== undefined && (
                        <>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    width: 40,
                                    height: 40,
                                }}
                                onClick={onZoomReset}
                                id="intransit-map-zoom-reset"
                                title="Reset Zoom"
                            >
                                <img
                                    src="/assets/images/icons/zoom-recenter.svg"
                                    alt="zoom reset"
                                    width={24}
                                    height={24}
                                />
                            </Box>
                            <Divider
                                orientation="horizontal"
                                flexItem
                                sx={{ mx: '5px' }}
                            />
                        </>
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: isZoomInDisabled ? 'default' : 'pointer',
                            width: 40,
                            height: 40,
                            opacity: isZoomInDisabled ? 0.5 : 1,
                        }}
                        onClick={isZoomInDisabled ? undefined : onZoomIn}
                        title="Zoom In"
                    >
                        <AddIcon sx={{ color: '#666666' }} />
                    </Box>
                    <Divider
                        orientation="horizontal"
                        flexItem
                        sx={{ mx: '5px' }}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: isZoomOutDisabled ? 'default' : 'pointer',
                            width: 40,
                            height: 40,
                            opacity: isZoomOutDisabled ? 0.5 : 1,
                        }}
                        onClick={isZoomOutDisabled ? undefined : onZoomOut}
                        title="Zoom Out"
                    >
                        <RemoveIcon sx={{ color: '#666666' }} />
                    </Box>
                </Box>
            </>
        )
    },
)

MapControls.displayName = 'MapControls'

export default MapControls
